/**
 * Result<T, E> — §16.2 Error Handling
 *
 * Сигнатура функции должна говорить правду об ошибках.
 * Вместо throws используем Result-тип — вызывающий код
 * ОБЯЗАН обработать ошибку, иначе TypeScript не скомпилирует.
 *
 * @example
 * ```ts
 * const result = await getBooking(id);
 * if (!result.ok) {
 *   logger.error(result.error.message);
 *   return;
 * }
 * // result.value доступен с правильным типом
 * console.log(result.value.slotStart);
 * ```
 */

/** Успешный результат */
export interface Ok<T> {
  readonly ok: true;
  readonly value: T;
}

/** Ошибочный результат */
export interface Err<E> {
  readonly ok: false;
  readonly error: E;
}

/** Discriminated union — успех или ошибка */
export type Result<T, E> = Ok<T> | Err<E>;

/** Фабрика успешного результата */
export function ok<T>(value: T): Ok<T> {
  return { ok: true, value };
}

/** Фабрика ошибочного результата */
export function err<E>(error: E): Err<E> {
  return { ok: false, error };
}
